const ListingTypeEnum = {
  PackageSubscriptionDefaultPurchase: 'package-subscription',
  SubscriptionNoSessions: 'subscription-no-sessions',
};
export default ListingTypeEnum;
